import axios from "axios";
import config from "../../Config";
import Cookie from "../../util/Cookie";

var auth_token = Cookie.get("X-Reycreo-Auth-Token");
var user_id = Cookie.get("X-Reycreo-Id");
console.log("auth_token -->>",auth_token);

const defaultHeader = {
    'content-type': 'application/json',
    "Accept": "application/json",
    "Cookie": `X-Reycreo-Auth-Token=${auth_token}; X-Reycreo-Id=${user_id};`
};

export default ({method = "GET", headers = defaultHeader, url = config.NETWORK_URL, uri = "", params, body}) => {

    let obj = {
        method,
        url: url + uri,
        headers,
        withCredentials: true
    }

    if(params){
        obj.params = params;
    } 

    if(body) {
        obj.data = body;
    }

    return axios(obj).then(result => {
        console.log("axios result-->>",result)
        return result;
    }).catch(err => {
        console.log("error in network call", err);
        throw err;
    });
}


// WEBPACK FOOTER //
// ./src/store/network/index.js